import axios from 'axios';
import store from '../store';
import {getSharedDocumentHeader} from '../data/apiUtils';
import {selectEffectiveOrg} from '../data/session';

const _exec = async (method, request) => {
  const state = store.getState();

  const {session} = state;
  const effectiveOrg = selectEffectiveOrg(state);

  return (
    await axios.request({
      method,
      headers: {
        Authorization: `Bearer ${session.accessToken}`,
        'x-inscope-org': effectiveOrg?.orgId ?? session.currentOrg?.orgId,
        ...getSharedDocumentHeader(),
      },
      baseURL: process.env.REACT_APP_BASE_API_URL,
      ...request,
    })
  ).data;
};

const _get = (path, {params = {}}) => {
  return _exec('get', {
    url: path,
    params,
  });
};

const _post = async (path, {params = {}, body}) => {
  return _exec('post', {
    url: path,
    data: body,
    params,
  });
};

export const downloadReports = (body, params) => {
  return _post('/app/reports/download', {body, params});
};

export const downloadISCFWorkbook = (params) => {
  return _post('/app/reports/iscf-workbook/download', {params});
};

export const downloadRuleTransactions = ({pliId, indirectPliId, period}) => {
  return _post(
    `/app/reports/iscf-workbook/rules/${pliId}-${indirectPliId}/transactions/download`,
    {params: {period}}
  );
};

export const getDepartments = () => {
  return _get('/app/departments', {});
};

// SCF Specific
export const getFile = (fileId) => {
  return _get(`/app/report/${fileId}/workbook`, {});
};

export const getFSLIs = () => {
  return _get('/app/fslis', {});
};
